"use client";

import { usePathname } from "@/i18n/navigation";
import { AdminSidebarProvider } from "../../hooks/AdminSidebarContext";

/**
 * Client component wrapper that conditionally provides AdminSidebarContext
 * only for admin routes. This ensures sidebar state is available where needed
 * without affecting other routes.
 */
export function AdminSidebarWrapper({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    if (!pathname.includes("/admin") && !pathname.includes("/superadmin")) return <>{children}</>;
    return <AdminSidebarProvider>{children}</AdminSidebarProvider>;
}

